import { render, staticRenderFns } from "./ChangePhone1.vue?vue&type=template&id=223da114&scoped=true"
import script from "./ChangePhone1.vue?vue&type=script&lang=js"
export * from "./ChangePhone1.vue?vue&type=script&lang=js"
import style0 from "./ChangePhone1.vue?vue&type=style&index=0&id=223da114&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223da114",
  null
  
)

export default component.exports